import { render, staticRenderFns } from "./RelationDetailAppointments.vue?vue&type=template&id=93ee9f50&"
import script from "./RelationDetailAppointments.vue?vue&type=script&lang=ts&"
export * from "./RelationDetailAppointments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
